// src/routes/ProtectedRoute.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { tokenStorage } from "../core/storage/tokenStorage";

export default function ProtectedRoute() {
  const location = useLocation();
  const access = tokenStorage.getAccess();

  if (!access) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}
